// extracted by mini-css-extract-plugin
module.exports = {"tagCloud":"tag-cloud-component-module__tagCloud___C87Oc"};